<template>
  <nav>
    <span v-for="(route, index) in routes" :key="route.path">
      <router-link :to="route.path">{{ route.name }}</router-link>
      <!-- 最後のリンクの後には縦棒を表示しない -->
      <span v-if="index < routes.length - 1"> | </span>
    </span>
  </nav>
  <router-view/>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  computed: {
    // Vuex ストアから routes ステートを取得
    // ...mapState(['routes'])
    ...mapState('island', ['routes'])
  },
  created() {
    // コンポーネント作成時に Vuex アクションを呼び出し、routes.json をフェッチ
    this.fetchRoutes();
  },
  methods: {
    // Vuex アクションのマッピング
    ...mapActions('island', ['fetchRoutes'])
  },
  watch: {
    '$store.state.island.routes': {
      handler(newRoutes, oldRoutes) {
        console.log('App.vue routes changed:', oldRoutes, '->', newRoutes);
      },
      deep: true // オブジェクトのネストされたプロパティの変更も監視
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}
nav a {
  font-weight: bold;
  color: #2c3e50;
}
nav a.router-link-exact-active {
  color: #42b983;
}
</style>